// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-link',
    // #endregion
    // #region Props
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        src: {
            type: String,
            required: false,
            default: ''
        },
        target: {
            type: String,
            required: false,
            default: ''
        },
        defaultClass: {
            type: String,
            required: false,
            default: 'link-primary'
        },
        modalMode: {
            type: String,
            required: false,
            default: 'default',
        },
    },
    data: () => ({
        mode: 'app',
        link: ''
    }),
    // #endregion
    // #region Constructor
    created() {
        this.updateMode();
    },
    // #endregion
    // #region Watch
    watch: {
        'src': function (value) {
            this.updateMode();
        },
        'target': function (value) {
            this.updateMode();
        },
    },
    // #endregion
    // #region Core
    methods: {
        // #region Action
        runAction() {
            //Args
            let tUrl = new URL(this.src);
            let tAction = tUrl.pathname.substring(2);
            let tQuestion = tUrl.searchParams.get("question");
            let tQuestion_Title = tUrl.searchParams.get("question.title");
            let tAddress = tUrl.searchParams.get("url");
            let tRefresh = tUrl.searchParams.get("refresh");
            let tMethod = tUrl.searchParams.get("method");
            //Message
            if (tQuestion) {
                host.notification.showModal("g-messages-question", { message: tQuestion, title: tQuestion_Title, successCallback: () => this.runCallback(tMethod, tAddress, tRefresh) }, { size: "default" });
            }
        },
        runActionClient() {
            //Args
            let tUrl = new URL(this.src);
            let tAction = tUrl.pathname.substring(2);
            //Run
            host.actions.tryExecute(tAction, {}, utils.urlParamsToObject(tUrl.searchParams));
        },
        runCallback(method, Url, refresh) {
            if (method === 'delete') {
                return this.$host.api.delete(Url)
                    .then((e) => {
                    if (refresh === "true") {
                        this.$host.eventBus.emit('refresh');
                    }
                })
                    .catch((e) => {
                    host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                });
            }
            else if (method === 'put') {
                return this.$host.api.put(Url)
                    .then((e) => {
                    if (refresh === "true") {
                        this.$host.eventBus.emit('refresh');
                    }
                })
                    .catch((e) => {
                    host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                });
            }
            else {
                return new Promise(() => { });
            }
        },
        // #endregion
        // #region Modal
        runModal() {
            // #region Vars
            let tData = {
                templateUrl: '`' + this.link + '`',
            };
            // #endregion
            host.notification.showModal(host.components.getComponent('g-server-page-modal'), tData, { size: this.modalMode });
        },
        // #endregion
        // #region Helper
        updateMode() {
            // #region Check
            if (!this.src) {
                this.mode = '';
                return;
            }
            // #endregion
            // #region Link
            let tLink = this.src.toLowerCase();
            //App => app://
            if (tLink.startsWith("app://")) {
                //Link
                this.mode = 'app';
                this.link = this.src.substr(6);
                //Optimize
                if (!this.link.startsWith('/')) {
                    this.link = '/' + this.link;
                }
            }
            //App => to://
            else if (tLink.startsWith("to://")) {
                //Link
                this.mode = 'app';
                this.link = this.src.substr(5);
                //Optimize
                if (!this.link.startsWith('/')) {
                    this.link = '/' + this.link;
                }
            }
            //App => action://
            else if (tLink.startsWith("action://")) {
                this.mode = 'action';
                this.link = this.src.substr(9);
            }
            else if (tLink.startsWith("client-action://")) {
                this.mode = 'client-action';
                this.link = this.src.substr(6);
            }
            else {
                this.mode = 'link';
                this.link = this.src;
            }
            // #endregion
            // #region Modal
            if (this.target === 'modal' && this.mode === 'app') {
                this.mode = 'app-modal';
            }
            // #endregion
        },
        // #endregion
    }
    //#endregion
});
// #endregion
